// extracted by mini-css-extract-plugin
export default {"flex":"XT","imgwrap":"YT","image":"ZT","textinfo":"aU","producttitle":"bU","bolder":"cU","block":"eU","info":"fU","moredetails":"gU","whitebox":"hU","old_price":"iU","discount":"jU"};
    if(module.hot) {
      // 1715188238672
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  